import React, { useEffect, useState, useCallback, useRef, memo } from "react";
import { Stage, Layer } from 'react-konva';
import Konva from 'konva';

import setting from "../../../assets/images/icons/console-6.svg";
import lightSetting from "../../../assets/images/icons/console-6.svg";

import widgetImage from "../../../assets/images/icons/whiteboard-fonction-feature-3.svg";
import Image_not_found from "../../../assets/images/Image_not_found.png";

import { screenState } from "../../../store/screen/slice";
import { useAppSelector } from "../../../store/hooks";

const Index = (props: any) => {
  const { config } = props;

  const handleImageError = (e: any) => {
    e.target.src = Image_not_found;
  }

  return (
    <React.Fragment>
      <div className=" overflow-hidden" style={{ height: '100%', width: '100%', position: 'absolute' }}>
        <div className="image-box">
          <img src={config.data.src} alt="" style={{ position: "absolute" }} onError={(e: any) => handleImageError(e)} />
        </div>
      </div>
    </React.Fragment>
  );




  // const stageContainerRef = useRef<HTMLDivElement | null>(null);
  // const stageRef = useRef<any>(null);

  // useEffect(() => {
  //   if (config.data.src && stageContainerRef.current) {
  //     // 使用 Konva 的 create 方法從 JSON 中重建 Stage
  //     const stage = Konva.Node.create(JSON.parse(config.data.src), stageContainerRef.current);
  //     stageRef.current = stage;
  //   }
  // }, [config.data.src]);

  // return <div ref={stageContainerRef}></div>;





};

export default memo(Index);